<template>
  <div>
    <div class="row">
      <div class="flex xs10 offset--xs1">
        <va-card :title="title">
          <div class="row">
            <div class='flex md12 sm6 xs12' v-if="showId">
              <va-input
                v-model='postId'
                label='文章ID'
                disabled
              />
            </div>
            <div class="flex md6 sm6 xs6">
              <va-select
                v-model="insertData.mentorId"
                label="导师名"
                textBy="nickname"
                :options="mentorNicknames"
                searchable
                width="350px"
              />
            </div>
            <div class='flex md12 sm6 xs12' v-show="insertData.coverUrl.length!==0">
              <va-card
                overlay
                :image='insertData.coverUrl'
                class="va-card-image"
              >
              </va-card>
            </div>
            <div class="flex md12 sm6 xs12">
              <va-card title='封面展示图'>
                <va-file-upload
                  type='single'
                  v-model='insertData.coverUrlArr'
                  @input="uploadImage"
                />
              </va-card>
            </div>
            <div class="flex md12 sm6 xs12">
              <va-select
                label="文章类型"
                v-model="insertData.type"
                :options="typeOptions"
              />
            </div>
            <div class="flex md12 sm6 xs12">
              <va-input
                v-model="insertData.title"
                label="标题"
                removable
              />
            </div>
            <div class="flex md12 sm6 xs12">
              <va-input
                v-model="insertData.desc"
                label="简短描述"
                type="textarea"
                removable
              />
            </div>
            <div class="flex md12 sm6 xs12">
              <vue-trix
                v-model="insertData.content"
                placeholder="精选内容"
                :config="captionConfig"
                @trix-attachment-add="handleAttachmentChanges"
              />
            </div>
            <div class="flex md12 sm6 xs12" v-if="insertData.type==='视频'">
              <va-input
                v-model="insertData.videoUrl"
                label="视频url"
              />
            </div>
            <div class="flex md12 sm6 xs12">
              <va-input
                v-model="insertData.sortNum"
                label="排序"
                placeholder="数字越大越靠前"
                removable
                :messages="message"
                :error="!!error.sortNumErrors.length"
                :error-messages="error.sortNumErrors"
                type="number"
                :min="1"
                oninput="if(value <0)value=1"
              />
            </div>
          </div>

          <div class='flex md2 offset--md5'>
            <va-button class="ma-0" color="primary" slot="trigger" @click="clickSubmit" :disabled="!submitButtonStatus">
              submit
            </va-button>
          </div>

        </va-card>
      </div>
    </div>
  </div>

</template>

<script>

import 'vue-trix'
import uploadApi from '../../../api/upload'
import postApi from '../../../api/liuxue/post'
import mentorApi from '../../../api/liuxue/mentor'
import { copyObject } from '../../../utils/common'

export default {
  data () {
    return {
      postId: null,
      insertData: {
        id: null,
        title: '',
        coverUrl: '',
        coverUrlArr: [],
        videoUrl: '',
        type: null,
        desc: '',
        content: '',
        mentorId: '',
        sortNum: null,
      },
      message: ['Required field'],
      error: {
        sortNumErrors: [],
      },
      title: '新增留学文章',
      showId: false,
      submitButtonStatus: true,
      typeOptions: ['图文', '视频'],
      allTags: [],
      captionConfig: {
        attachments: {
          preview: {
            caption: {
              name: false,
              size: false,
            },
          },
        },
      },
      mentors: [],
      mentorNicknames: [],
      loading: false,
    }
  },
  created () {
    const params = this.$route.params
    console.log(params)
    this.postId = params.postId
    if (params.postId != null) {
      this.showId = true
      this.title = '编辑精选内容'
      // 通过id获取详情
      postApi.getPost(params.postId).then(response => {
        copyObject(response, this.insertData)
        // eslint-disable-next-line no-prototype-builtins
        if (response.hasOwnProperty('type')) {
          if (response.type === 1) {
            this.insertData.type = '图文'
          } else {
            this.insertData.type = '视频'
          }
        }
        // 设置mentor
        this.insertData.mentorId = {
          id: response.mentorId,
          nickname: response.mentorName + ' (' + response.mentorId + ')',
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    }
    // 加载liuxueMentor用户
    this.listMentor()
  },
  methods: {
    listMentor () {
      const params = {
        pageSize: 100,
        pageNumber: 1,
      }
      mentorApi.listMentor(params)
        .then(response => {
          this.mentors = response.mentors
          this.mentorNickname()
        })
    },
    mentorNickname () {
      const nicknames = []
      for (let i = 0; i < this.mentors.length; i++) {
        const item = {}
        item.id = this.mentors[i].id
        item.nickname = this.mentors[i].name + ' (' + item.id + ')'
        nicknames.push(item)
      }
      console.log(nicknames)
      this.mentorNicknames = nicknames
    },
    clickSubmit () {
      this.checkField()
      this.changeButtonStatus(false)
      if (this.insertData.coverUrl === '') {
        this.changeButtonStatus(true)
        this.showToast('请上传图片', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
        return
      }
      const data = {
        mentorId: this.insertData.mentorId.id,
        desc: this.insertData.desc,
        coverUrl: this.insertData.coverUrl,
        title: this.insertData.title,
        sortNum: this.insertData.sortNum,
      }
      if (this.insertData.type === '图文') {
        data.type = 1
        data.content = this.insertData.content
        data.desc = this.insertData.desc
      } else if (this.insertData.type === '视频') {
        data.type = 2
        if (this.insertData.videoUrl === '') {
          this.changeButtonStatus(true)
          this.showToast('请上传视频', {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
          return
        }
        data.videoUrl = this.insertData.videoUrl
        data.content = this.insertData.content
      }
      console.log(this.insertData)
      if (this.postId != null) {
        data.id = this.postId
        postApi.updatePost(this.postId, data).then(response => {
          if (response.success === true) {
            this.showToast('留学文章更新成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'listPost' })
          }
          this.$router.push({ name: 'listPost' })
        }).catch(error => {
          this.changeButtonStatus(true)
          alert(error)
        })
      } else {
        postApi.savePost(data).then(response => {
          if (response.success === true) {
            this.showToast('留学文章添加成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'listPost' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          alert(error.msg)
        })
      }
    },
    checkField () {
      this.error.sortNumErrors = this.insertData.sortNum ? [] : ['sortNum is required']
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
    uploadImage () {
      if (this.insertData.coverUrlArr.length === 0) return
      const formData = new FormData()
      formData.append('type', 'IMAGE')
      formData.append('file', this.insertData.coverUrlArr[this.insertData.coverUrlArr.length - 1])
      uploadApi.uploadImage(formData).then(response => {
        console.log(response)
        this.insertData.coverUrl = response.url
        this.showToast('上传图片成功', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    handleAttachmentChanges (event) {
      const file = event.attachment.file
      const formData = new FormData()
      formData.append('type', 'image')
      formData.append('file', file)
      uploadApi.uploadImage(formData).then(response => {
        event.attachment.setAttributes({ url: response.url })
        this.showToast('上传图片成功', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      }).catch(error => {
        console.log(error)
      })
    },
  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
